/**
 * Confirmação por biometria de uma ação pedida pelo chat (US-3103) — página pública aberta no celular — Nexora Grid.
 *
 * Criado em: 25/10/2026 · Última modificação: 25/10/2026 · Versão: 1.0.0
 *
 * `/confirmar-acao#<token>`: o bot manda o link quando a pessoa pede "ciente", aprova o rascunho de painel ou envia o
 * cadastro em campo. A página mostra O QUE vai ser feito e pede a assinatura da passkey do celular cadastrado; o
 * desafio é o resumo da própria ação, então a assinatura não serve para outra. A assinatura vale 60 s depois de tocar
 * em confirmar; conferida, o servidor executa a ação e o resultado aparece aqui e no chat. Manobra nunca passa por aqui.
 */
import { useEffect, useState } from "react";
import { api, ErroApi } from "../api";
import { mensagemDaFalha, usarPasskey } from "./CadastroAparelho";
import { Logomarca } from "../marca";

type Opcoes = { tipo: "autenticar"; opcoes: Record<string, any>; descricao: string; usuario: string; aparelho: string; segundos: number };

export function ConfirmarAcao() {
  const token = window.location.hash.replace(/^#/, "");
  const [dados, setDados] = useState<Opcoes | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [feito, setFeito] = useState<string | null>(null);
  const [esperando, setEsperando] = useState(false);
  const suportado = typeof window.PublicKeyCredential !== "undefined" && window.isSecureContext;

  useEffect(() => {
    if (!token) { setErro("Link incompleto. Abra o link exatamente como chegou no chat."); return; }
    api<Opcoes>("/v1/aparelhos/confirmacao/opcoes", { metodo: "POST", corpo: { token } })
      .then(setDados).catch((e) => setErro(e instanceof ErroApi ? e.message : "Servidor indisponível."));
  }, [token]);

  const confirmar = async () => {
    setErro(null);
    setEsperando(true);
    try {
      // desafio novo a cada toque: a assinatura vale só alguns segundos
      const novas = await api<Opcoes>("/v1/aparelhos/confirmacao/opcoes", { metodo: "POST", corpo: { token } });
      const credencial = await usarPasskey("autenticar", novas.opcoes);
      const fim = await api<{ texto: string }>("/v1/aparelhos/confirmacao/concluir", { metodo: "POST", corpo: { token, credencial } });
      setFeito(fim.texto);
    } catch (falha) {
      setErro(mensagemDaFalha(falha));
    } finally {
      setEsperando(false);
    }
  };

  return (
    <div className="nx-tela tela-login" data-tema="cco">
    <main className="nx-cartao cartao-login form-conta" aria-label="Confirmar ação">
      <Logomarca className="logo-login" />
      <h2>Confirmar com biometria</h2>
      {feito ? <p role="status">{feito}</p> : (
        <>
          {dados && (
            <>
              <p><b>{dados.descricao}</b></p>
              <p className="nx-suave">{dados.usuario}, confirme com a biometria ou o PIN do aparelho "{dados.aparelho}". Depois de tocar em
                confirmar, você tem {dados.segundos} s. Se não foi você que pediu, não confirme.</p>
            </>
          )}
          {!suportado && <p className="erro" role="alert">Este navegador não usa passkey. Abra o link no navegador padrão do celular (Chrome ou Safari), em endereço https.</p>}
          {erro && <p className="erro" role="alert">{erro}</p>}
          <button type="button" className="nx-botao nx-botao-principal" disabled={!dados || !suportado || esperando} onClick={() => void confirmar()}>
            {esperando ? "Confirme no celular…" : "Confirmar com biometria ou PIN"}</button>
        </>
      )}
    </main>
    </div>
  );
}
